<template>
  <div class="models">
    <TextTable
        :all_data = "all_data"
    />
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'Models',
  components: {
    TextTable
  },
  data () {
    return {
      all_data: {}
    }
  },
  created () {
    this.$http.v1.getModelsDevices((response) => {
      this.all_data = response.data
    })
  }
}
</script>

<style lang="scss" scoped>
  .models{
    height: 100%;
    ::v-deep .response_table table {
      th, td {
        text-align: left;
      }
    }
  }
  @media (max-width: 1300px){
    .response_table{
      font-size: 12px;
    }
  }
</style>
